// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1IN4e","row":"styles_row__3OaLi"};